module.exports = __webpack_public_path__ + "img/serve1.3a618e9a.png";